import React, { useState, useEffect, useRef } from "react";
import {
  Checkbox,
  Button,
  TextField,
  Typography,
  IconButton,
  FormHelperText,
  makeStyles,
} from "@material-ui/core";

import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

const useStyles = makeStyles((theme) => ({
  outlinedButtonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#0D47A1",
    height: "34px",
    textTransform: "none",
  },
  buttonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    "&:active": {
      backgroundColor: "#0D47A1",
    },
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  textFieldStyle: {
    marginBottom: 5,
    marginTop: 20,
    "& .MuiInputLabel-outlined": {
      fontSize: 16,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 10,
      fontSize: 16,
    },
  },
  errorStyle: {
    marginLeft: 5,
    marginTop: 0,
    fontSize: 14,
    fontFamily: "Arial",
  },

  datePickerStyle: {
    width: "100%",
    marginBottom: 5,
    "& .MuiInputLabel-outlined": {
      fontSize: 16,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 10,
      fontSize: 16,
    },
  },
}));

export default function AddEventToTemplateDialog({
  text,
  closeDialog,
  handleAddEvent,
  eventType,
  periodName,
  noOfWeeks
}) {
  const classes = useStyles();
  const [open, setOpen] = useState(true);
  const [errorMsg, setErrorMsg] = useState({
    noOfDaysAfter: "",
    eventName: "",
  });
  const [eventNameValue, setEventNameValue] = useState("");
  const [descValue, setDescValue] = useState("");
  const [attendanceRequired, setAttendanceRequired] = useState(false);
  const [noOfDaysAfter, setNoOfDaysAfter] = useState("");

  const textLabel = "Which Day in Period (1 to " + parseInt(noOfWeeks*7) + ")";

  
  const validateNoOfDays = (value) => {
    setNoOfDaysAfter(parseInt(value));
    if (parseInt(value) < 1) {
      setErrorMsg({ noOfDaysAfter: "Enter an integer greater than zero." });
    } else if (value.toString().trim() === "") {
      setErrorMsg({ noOfDaysAfter: "No of Days cannot be blank." });
    } else if (value > parseInt(noOfWeeks*7)) {
      setErrorMsg({ noOfDaysAfter: "The day cannot be greater than number of days in this period." });
    } else {
      setErrorMsg({ noOfDaysAfter: "" });      
    }
  };
  


  const handleClose = () => {
    setOpen(false);
    closeDialog && closeDialog();
  };

  const handleSave = () => {
    if (eventNameValue.trim() === "") {
      setErrorMsg({ eventName: "Event Name cannot be blank." });
    
    } else if (!noOfDaysAfter) {
      setErrorMsg({ noOfDaysAfter: "No of Days cannot be blank." });

    } else if (noOfDaysAfter > parseInt(noOfWeeks*7)) {
      setErrorMsg({ noOfDaysAfter: "The day cannot be greater than number of days in this period." });

    } else {
      setOpen(false);
      handleAddEvent(
        eventNameValue,
        eventType,
        noOfDaysAfter,        
        descValue,
        attendanceRequired
      );
    }
  };

  const handleEventNameChange = (event) => {
    if (event.target.value.trim() === "")
      setErrorMsg({ eventName: "Event Name cannot be blank." });
    else setErrorMsg({ eventName: "" });
    setEventNameValue(event.target.value);
  };
  const handleDescChange = (event) => {
    // Limit input to 254 characters
    if (event.target.value.length <= 254) {
      setDescValue(event.target.value);
    }
  };
  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "100%",
              maxWidth: "500px",
            },
          },
        }}
      >
        <DialogTitle
          sx={{ m: 0, p: 2 }}
          id="alert-dialog-title"
          style={{
            display: "flex",
            justifyContent: "space-between",
            paddingBottom: 0,
          }}
        >
          <Box mt={1} ml={1}>
            Add Event
          </Box>
          {closeDialog ? (
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                align: "right",
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          ) : null}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">

            <Box
              pt={1}
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <Typography variant="h2">Period Name:</Typography>
              <Typography variant="h3" style={{ paddingLeft: 5 }}>
                {periodName} ({noOfWeeks} {noOfWeeks === 1 ? "Week" : "Weeks"})
              </Typography>
            </Box> 

            <Box
              pt={1}
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <Typography variant="h2">Event Type:</Typography>
              <Typography variant="h3" style={{ paddingLeft: 5 }}>
                {eventType}
              </Typography>
            </Box>
            <TextField
              className={classes.textFieldStyle}
              fullWidth
              autoFocus
              required
              label="Event Name"
              margin="normal"
              name="eventName"
              variant="outlined"
              id="eventName"
              value={eventNameValue}
              onChange={handleEventNameChange}
            />
            {errorMsg && (
              <FormHelperText className={classes.errorStyle} error>
                {errorMsg.eventName}
              </FormHelperText>
            )}

            <TextField
              className={classes.textFieldStyle}
              fullWidth
              required
              label={textLabel}
              margin="normal"
              name="noOfDaysAfter"
              type="number"
              value={noOfDaysAfter}
              variant="outlined"
              InputProps={{
                inputProps: { min: 0, pattern: "[0-9]*" },
              }}
              onKeyPress={(e) => {
                if (e?.key === "-" || e?.key === "+") {
                  e.preventDefault();
                }
              }}
              onChange={(e) => validateNoOfDays(e.target.value)}
              id="noOfDaysAfter"
            />

            
            {errorMsg && (
              <FormHelperText className={classes.errorStyle} error>
                {errorMsg.noOfDaysAfter}
              </FormHelperText>
            )}

            <TextField
              className={classes.textFieldStyle}
              fullWidth
              label="Description"
              margin="normal"
              name="Description"
              variant="outlined"
              id="Description"
              value={descValue}
              onChange={handleDescChange}
              multiline
              rows={4}
            />
            
            <Typography variant="h3">
              Attendance Required?{" "}
              <Checkbox
                onChange={(e) => setAttendanceRequired(e.target.checked)}
                id="Attendance Required?"
              />
            </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ justifyContent: "center" }}>
          <Box mb={2}>
            <Button
              variant="contained"
              color="primary"
              className={classes.buttonStyle}
              style={{ marginRight: 5 }}
              onClick={handleSave}
            >
              Save
            </Button>
            <Button
              variant="text"
              color="primary"
              className={classes.outlinedButtonStyle}
              onClick={handleClose}
            >
              Cancel
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
    </div>
  );
}
